import React from "react";

import PropTypes from "prop-types";

const FoldersTitle = ({ title, subTitle }) => (
  <div className={"newfolder--wrapper--content--heading"}>
    <h2 className={"newfolder--wrapper--content--heading--title heading--24"}>
      {title}
    </h2>
    <h5 className={"newfolder--wrapper--content--heading--subtitle text--18"}>
      {subTitle}
    </h5>
  </div>
);

FoldersTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

FoldersTitle.defaultProps = {
  title: "",
  subTitle: "",
};
export default FoldersTitle;
